import React, { useEffect, useState } from 'react'
import { Box, Stack, Typography, Grid, Card, CircularProgress, Badge } from '@mui/material';
import MDButton from 'components/MDButton';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import defaultImage from 'assets/images/placeholder-image.png';
import { openSnackbar } from '../../../../redux/slices/common';
import { openCustomModalDialog } from '../../../../redux/slices/modalSlice';
import CommonLayout from 'layouts/DashboardLayout';
import { fetchBRBByID, updateBRBByID } from '../../../../redux/slices/hyperwolf/settings';
import AngleRightIcon from 'common/customIcons/angle_right';
import Loader from 'common/Loader';


const EditBRBImage = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isUploading } = useSelector(state => state.common);
    const [defaultImageData, setDefaultImageData] = useState({
        desktopImages: {},
        mobileImages: {}
    });
    const { user } = useSelector(state => state.auth);

    const [activeImageType, setActiveImageType] = useState(null);
    const { isLoading, isUpdateLoading } = useSelector(state => state.hyperwolfSettings);
    const { brbID } = useParams();

    const showError = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };

    const handleImageOpenModal = async (mediaType,dimensions) => {
        setActiveImageType(mediaType);
        // Open your image selection modal here
        // Simulate image selection - replace with actual modal logic
        dispatch(
            openCustomModalDialog({
                modalData: {
                    type: mediaType,
                    dimensions:dimensions,
                    handleSave: (data) => handleSaveImage(data, mediaType)
                },
                modal: "ADD_DEVICE_IMAGE_MODAL"
            })
        );
    };

    const handleSaveImage = (imageData, mediaType) => {
        // Update the default image data with new image
        setDefaultImageData(prev => ({
            ...prev,
            [mediaType === 'desktop' ? 'desktopImages' : 'mobileImages']: {
                ...prev[mediaType === 'desktop' ? 'desktopImages' : 'mobileImages'],
                imageUrl: imageData?.imageUrl, // Adjust based on your image data structure
                altText: imageData.altText || '',
                mediaType: imageData?.mediaType
            }
        }));

        // showError(`${mediaType} image updated successfully`, 'success');
    };

    const handleSubmit = () => {
        const payload = {
            desktopImages: defaultImageData?.desktopImages,
            mobileImages: defaultImageData?.mobileImages,
            updatedBy: user?.name
        }
        dispatch(updateBRBByID({ payload, brbID })).unwrap().then(res => {
            navigate(-1)
            showError(res?.message, 'success');

        }).catch((res) => {
            showError(res?.message, 'error');

        });

    }

    const ImageUploadSection = ({ mediaType, title, dimensions }) => {
        const [modalOpen, setModalOpen] = useState(false);
        const [hasError, setHasError] = useState(false);

        const imageData = mediaType === 'desktop'
            ? defaultImageData.desktopImages
            : defaultImageData.mobileImages;

        const handleImageSelect = () => {
            handleImageOpenModal(mediaType);
            setModalOpen(false);
        };

        const handleChooseFromLibrary = () => {
            handleImageOpenModal(mediaType);
            setModalOpen(false);
        };

        // Check if media is video
        const isVideo = imageData?.mediaType === 'video' ||
            imageData?.imageUrl?.match(/\.(mp4|webm|ogg|mov|avi)$/i);

        return (

            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" fontWeight="medium" mb={1}>
                    {title}
                </Typography>
                <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} style={{ width: "100%" }}>
                    <Badge
                        overlap='circular'
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        badgeContent={
                            isUploading && activeImageType === mediaType ?
                                <CircularProgress size={32} color='primary' /> : ''
                        }
                        style={{ width: "100%" }}
                    >
                        {imageData?.imageUrl ? (
                            <Box sx={{ width: '100%', position: 'relative', display: 'inline-block' }}>
                                {/* Video Player */}
                                {isVideo ? (
                                    <Box
                                        sx={{
                                            width: '100%',
                                            height: '250px',
                                            borderRadius: "12px",
                                            overflow: 'hidden',
                                            border: hasError ? '2px solid #fd4438' : 'none',
                                            boxShadow: hasError ? '0 0 0 1px #fd4438' : '0 0 1px rgb(0 0 0 / 20%)',
                                            backgroundColor: '#000'
                                        }}
                                    >
                                        <video
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderRadius: "12px",
                                            }}
                                            controls
                                            onError={(e) => {
                                                // setHasError(true);
                                            }}
                                        >
                                            <source src={imageData.imageUrl} type="video/webm" />
                                            <source src={imageData.imageUrl} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </Box>
                                ) : (
                                    /* Image Preview */
                                    <img
                                        style={{
                                            width: '100%',
                                            height: '250px',
                                            borderRadius: "12px",
                                            objectFit: 'cover',
                                            border: hasError ? '2px solid #fd4438' : 'none',
                                            boxShadow: hasError ? '0 0 0 1px #fd4438' : '0 0 1px rgb(0 0 0 / 20%)',
                                        }}
                                        src={imageData.imageUrl}
                                        alt={imageData.altText || `${title} preview`}
                                        onError={(e) => {
                                            e.target.src = defaultImage;
                                            // setHasError(true);
                                        }}
                                    />
                                )}

                                <label className='upload-change-image'>
                                    <MDButton
                                        sx={{
                                            minWidth: '180px',
                                            mt: 1
                                        }}
                                        type='button'
                                        variant='outlined'
                                        color='secondary'
                                        component='span'
                                        // onClick={() => setModalOpen(true)} // option libarry and device fro now
                                        onClick={() => handleImageOpenModal(mediaType,dimensions)}

                                    >
                                        <div className='add-change-img-sec'>
                                            <p>Change {isVideo ? 'Video' : 'Image'} {dimensions}</p>
                                        </div>
                                    </MDButton>
                                </label>
                            </Box>
                        ) : (
                            /* Upload Button when no media */
                            <Box onClick={() => setModalOpen(true)} sx={{ cursor: 'pointer' }}>
                                <MDButton
                                    sx={{
                                        minWidth: '180px',
                                        border: hasError ? '2px solid #fd4438' : '1px solid #e0e0e0',
                                        backgroundColor: hasError ? '#ffebee' : 'white',
                                        color: hasError ? '#fd4438' : '#2E2E3A',
                                        '&:hover': {
                                            backgroundColor: hasError ? '#ffcdd2' : '#f5f5f5'
                                        }
                                    }}
                                    type='button'
                                    variant='outlined'
                                    disabled={isUploading}
                                >
                                    <div style={{ textAlign: 'center', padding: '8px' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <g clipPath="url(#clip0_13676_49992)">
                                                <path d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z" fill={hasError ? "#fd4438" : "#2E2E3A"} />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_13676_49992">
                                                    <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <h5 style={{ color: hasError ? '#fd4438' : '#2E2E3A', margin: '4px 0' }}>
                                            {title}
                                        </h5>
                                        <p style={{ color: hasError ? '#fd4438' : '#2E2E3A', margin: 0, fontSize: '12px' }}>
                                            {dimensions}
                                        </p>
                                    </div>
                                </MDButton>
                            </Box>
                        )}
                    </Badge>

                    {/* Modal Options */}
                    {modalOpen && (
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            <MDButton
                                sx={{
                                    minWidth: '160px',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: 'white',
                                    color: '#2E2E3A',
                                    '&:hover': { backgroundColor: '#f5f5f5' }
                                }}
                                type='button'
                                variant='outlined'
                                onClick={handleChooseFromLibrary}
                                disabled={isUploading}
                            >
                                Choose from library
                            </MDButton>

                            <MDButton
                                sx={{
                                    minWidth: '160px',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: 'white',
                                    color: '#2E2E3A',
                                    '&:hover': { backgroundColor: '#f5f5f5' }
                                }}
                                type='button'
                                variant='outlined'
                                disabled={isUploading}
                                onClick={handleImageSelect}
                            >
                                Upload From device
                            </MDButton>
                        </Box>
                    )}
                </Stack>


            </Box>
        );
    };

    const brbGraphicsByID = () => {
        dispatch(fetchBRBByID(brbID)).unwrap().then(res => {
            setDefaultImageData(res?.brb)

        }).catch(() => {
            setDefaultImageData({})
        });
    }

    useEffect(() => {
        brbGraphicsByID()
    }, [])

    return (
        <CommonLayout>
            <Box p={{ xs: 2, sm: 3, lg: 4 }} pb={{ lg: 2 }} className="create-time-slots">
                <Stack direction="row" justifyContent="space-between" flexWrap="wrap" alignItems="stretch" gap={2} mb={2}>
                    <span onClick={() => navigate(-1)} className='cur-pointer'>
                        <Box display="flex" gap={1} alignItems="center" color='text.main' lineHeight={1}>
                            <AngleRightIcon fontSize="14px" />
                            <Typography variant='h5' style={{ display: "flex", alignItems: "center", gap: "5px" }}>Express Menu - <span style={{ fontSize: "16px" }}>Shop Closed Graphics</span></Typography>

                        </Box>
                    </span>
                </Stack>
                {
                    isLoading ? <Loader /> :
                        <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
                            <Typography variant='h5' fontWeight="semibold" color="secondary" mb={2}>
                                {defaultImageData?.defaultImage ? "Default BRB Banner for all regions" :defaultImageData?.regionName}
                            </Typography>

                            <Grid container spacing={2.5}>
                                <Grid item xs={12} md={4} lg={3}>
                                    {/* Desktop Image */}
                                    <ImageUploadSection
                                        mediaType="desktop"
                                        title="Desktop"
                                        dimensions="1252×560"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} lg={3}>
                                    {/* Mobile Image */}
                                    <ImageUploadSection
                                        mediaType="mobile"
                                        title="Mobile"
                                        dimensions="406×180"
                                    />
                                </Grid>
                            </Grid>
                        </Card>
                }

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} my={3}>
                    <MDButton
                        sx={{ minWidth: '175px' }}
                        type='submit'
                        variant='contained'
                        onClick={handleSubmit}
                        color={'primary'}
                        disabled={isLoading || isUpdateLoading}
                    >
                        {isLoading || isUpdateLoading ? <CircularProgress size={14} justifyContent="center" style={{ color: "#ffffff" }} /> : 'Update Changes'}
                    </MDButton>
                </Stack>
            </Box>
        </CommonLayout>
    )
}

export default EditBRBImage